export function Toast({ message }: { message: string }) {
  return (
    /*
      Clears the composer, which clears the tab bar. Both publish their real
      heights — see bottom-bars.ts. This used to be `bottom-[172px]` with a
      comment saying the ask bar was "~68px tall", which was true on an iPad and
      wrong on the first phone anybody opened.
    */
    <div
      className="pointer-events-none fixed inset-x-0 z-50 flex justify-center px-4"
      style={{ bottom: "calc(var(--tabbar-h, 92px) + var(--composer-h, 68px) + 1rem)" }}
    >
      <div
        className="pop disp max-w-full rounded-full bg-gold px-5 py-3 text-center text-[17px] text-night shadow-[0_8px_0_rgba(0,0,0,.25)]"
        role="status"
        aria-live="polite"
      >
        {message}
      </div>
    </div>
  );
}
